"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiOpciFrequenceTransaction = void 0;
exports.ESubScpiOpciFrequenceTransaction = {
    mensuelle: "mensuelle",
    trimestrielle: "trimestrielle",
    annuelle: "annuelle",
    annuelle_supereur: "annuelle_supereur",
};
